module.exports = __webpack_public_path__ + "static/media/tictac.325ef671.svg";